export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10625.a1159780.jpg";